<template>
  <div class="form">
    <div class="form__head">
      <div class="form__title form__title_white mb10">
        {{ $t("forms.billingAddress") }}
        <button
          type="reset"
          class="form__address-close"
          @click="$emit('close')"
        >
          <img src="@/assets/images/close.svg" width="24px" alt />
        </button>
      </div>
    </div>

    <div class="form__content">
      <div class="form-item form-item_flex mb24">
        <el-select
          class="greetings-select"
          v-model="address.greetings"
          :placeholder="$t('forms.sex')"
        >
          <el-option
            v-for="item in greets"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>

      <div class="form-item mb24">
        <el-input
          :placeholder="$t('forms.firstName')"
          type="text"
          v-model="address.first_name"
          autocomplete="off"
        ></el-input>
      </div>

      <div class="form-item mb24">
        <el-input
          :placeholder="$t('forms.lastName')"
          type="text"
          v-model="address.last_name"
          autocomplete="off"
        ></el-input>
      </div>

      <div class="form-item form-item_flex form-item_w100">
        <autocomplete-input
          :autocompleteValue="autocompleteValue"
          :placeholder="$t('forms.street')"
          @fill="fill"
          class="mb24"
        />
      </div>

      <div class="form-item form-item_flex form-item_center">
        <button
          type="reset"
          class="btn btn_upper btn_w240"
          @click="done"
          :disabled="!isValid || isSubmitted"
          :class="{
            btn_disabled: !isValid || isSubmitted,
          }"
        >{{ $t("buttons.save") }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import autocompleteInput from "@/components/base/autocomplete/index";
import { required } from "vuelidate/lib/validators";

export default {
  name: "add-billing-address",
  components: {
    autocompleteInput
  },
  computed: {
    ...mapGetters({
      address: "address/billingAddress"
    }),

    // isValid() {
    //   if (this.address.postcode == "" || this.address.postcode == null) {
    //     return false;
    //   }

    //   if (this.address.city == "" || this.address.city == null) {
    //     return false;
    //   }

    //   if (this.address.street == "" || this.address.street == null) {
    //     return false;
    //   }

    //   if (this.address.country == "" || this.address.country == null) {
    //     return false;
    //   }

    //   if (this.address.last_name == "" || this.address.last_name == null) {
    //     return false;
    //   }

    //   if (this.address.first_name == "" || this.address.first_name == null) {
    //     return false;
    //   }

    //   return true;
    // }
    isValid() {
      return !this.$v.$invalid;
    }
  },
  validations: {
    address: {
      first_name: {
        required
      },
      last_name: {
        required
      },
      country: {
        required
      },
      city: {
        required
      },
      street: {
        required
      },
      house: {
        required
      },
      postcode: {
        required
      }
    }
  },
  data() {
    return {
      autocompleteValue: "",
      greets: [
        { label: this.$t("forms.mister"), value: "Herr" },
        { label: this.$t("forms.miss"), value: "Frau" }
      ],
      isSubmitted: false
    };
  },
  methods: {
    fill({ autocompleteValue, address }) {
      this.address.city = address.city;
      this.address.country = address.country;
      this.address.house = address.house;
      this.address.postcode = address.postcode;
      this.address.street = address.street;
    },
    done() {
      this.$emit("done");
      this.isSubmitted = true;

      setTimeout(() => {
        this.isSubmitted = false;
      }, 1000);
    }
  },
  created() {
    if (!this.address.street) {
      return;
    }

    this.autocompleteValue = `${this.address.street} ${this.address.house} ${this.address.postcode} ${this.address.city}`;
  }
};
</script>

<style lang="scss" scoped>
.form__address-close {
  background: transparent;
  border: none;
  position: absolute;
  right: 0;
  padding: 0;
  outline: none;
  cursor: pointer;
}
</style> 

<style>
.greetings-select input {
  text-transform: capitalize;
}
</style>